import { Injectable } from "@angular/core";
import { Feature } from "./feature";
import { WebApiService } from "src/app/shared/web-api/web-api.service";
import { concatMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class FeatureService {
  constructor(
    private webApiService: WebApiService
  ) {}

  getFeatures() {
    return this.webApiService
      .get<Feature[]>(`/users/current/beta/features`)
      .pipe(concatMap((f) => f));
  }
}
